import React, { useEffect, useRef, useState } from 'react';
import { FaCheck, FaChevronDown, FaGlobeAmericas } from 'react-icons/fa';
import { useIdioma } from './context/IdiomaContext';

const OPCIONES = [{ codigo: 'es', nombre: 'Español' }, { codigo: 'en', nombre: 'English' }];

export default function SelectorIdioma() {
  const { idioma, establecerIdioma, t } = useIdioma();
  const [abierto, setAbierto] = useState(false);
  const ref = useRef(null);
  const actual = OPCIONES.find((opcion) => opcion.codigo === idioma);
  useEffect(() => {
    const cerrar = (e) => { if (ref.current && !ref.current.contains(e.target)) setAbierto(false); };
    document.addEventListener('mousedown', cerrar);
    return () => document.removeEventListener('mousedown', cerrar);
  }, []);
  return (
    <div className="selector-idioma" ref={ref}>
      <button type="button" className="selector-idioma__boton" onClick={() => setAbierto(!abierto)} aria-haspopup="listbox" aria-expanded={abierto} aria-label={`${t('Idioma')}: ${actual.nombre}`}>
        <FaGlobeAmericas className="selector-idioma__icono" aria-hidden="true" />
        <span className="selector-idioma__nombre">{actual.nombre}</span>
        <FaChevronDown size="11" aria-hidden="true" />
      </button>
      {abierto && <ul className="selector-idioma__menu" role="listbox" aria-label={t('Selecciona tu idioma')}>
        {OPCIONES.map((opcion) => <li key={opcion.codigo} role="option" aria-selected={idioma === opcion.codigo} onClick={() => { establecerIdioma(opcion.codigo); setAbierto(false); }}>
          <span>{opcion.codigo === 'es' ? t('Español') : opcion.nombre}</span>{idioma === opcion.codigo && <FaCheck size="12" aria-hidden="true" />}
        </li>)}
      </ul>}
    </div>
  );
}
